import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { User } from 'app/core/user/user.types';
import { environment } from 'environments/environment';
import { now } from 'lodash';
import { of, map, Observable, ReplaySubject, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UserService {
    private _user: ReplaySubject<User> = new ReplaySubject<User>(1);

    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for user
     *
     * @param value
     */

    set user(user: User) {
        //sessionStorage.setItem('user', JSON.stringify(user));
        localStorage.setItem('user', JSON.stringify(user));
    }

    get user$(): Observable<User> {
        /* return of(JSON.parse(sessionStorage.getItem('user') ?? '')); */
        return of(JSON.parse(localStorage.getItem('user') ?? ''));
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get the current logged in user data
     */
    get(): Observable<User> {
        return this._user.asObservable();
    }
    get user(): User | null {
      const data = localStorage.getItem('user');
      return data ? JSON.parse(data) : null;
    }

    /**
     * Update the user
     *
     * @param user
     */
    update(user: User): Observable<any> {
        /* return this._httpClient.patch<User>('api/common/user', {user}).pipe(
            map((response) =>
            {
                this._user.next(response);
            }),
        ); */
        return this._user.asObservable();
    }

    cambiarEmpresa(payload: { idempresa: number }): Observable<any> {
        return this._httpClient.post<any>(`${environment.usuario.cambiar_empresa}`, payload);
    }
}
